module.exports = __webpack_public_path__ + "img/gift_title_03.136da154.png";